import type { Membership } from '@kalos/kalos-rpc';

/**
 * Plan name for a membership. Commercial plans all anchor to the one shared `Custom` type, so
 * their real name is the base instance line — which only arrives when the request sets `withLines`.
 */
export const membershipPlanLabel = (
  m: Pick<Membership, 'isCommercial' | 'baseLineName' | 'membershipTypeId'>,
  typeName?: string,
): string => {
  if (m.isCommercial) {
    const baseName = m.baseLineName || 'Custom plan';
    return baseName === 'Custom plan' ? 'Custom plan' : `Custom · ${baseName}`;
  }
  return typeName || `Plan #${m.membershipTypeId}`;
};
